// Libraries
import I18n from 'i18next'
import { get, includes, map, toString } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Button, Card, Col, DatePicker, Row, Select, Tabs } from 'antd'

const { Option } = Select
const { TabPane } = Tabs

class ExtractionList extends Component {
  static propTypes = {
    // Fonctions héritées du constructeur
    constructorFunctions: PropTypes.objectOf(PropTypes.func),
    // État hérité du constructeur
    constructorState: PropTypes.object
  }

  static defaultProps = {
    constructorFunctions: {},
    constructorState: {}
  }

  _permitTypeOptions = [
    { value: 'all_permit',      label: I18n.t('pages.extraction.fields.permitType.options.all_permit') },
    { value: 'permit',          label: I18n.t('pages.extraction.fields.permitType.options.permit') },
    { value: 'firepermit',      label: I18n.t('pages.extraction.fields.permitType.options.firepermit') },
    { value: 'cleaningpermit',  label: I18n.t('pages.extraction.fields.permitType.options.cleaningpermit') },
    { value: 'capacitypermit',  label: I18n.t('pages.extraction.fields.permitType.options.capacitypermit') },
    { value: 'searchpermit',    label: I18n.t('pages.extraction.fields.permitType.options.searchpermit') }
  ]

  _renderDateFilters = ({ dateFrom, dateTo, onChangeFrom, onChangeTo, onDownload, isDownloading, companyId, onChangeCompany, companyOptions, permitType, onChangePermitType }) => (
    <Row type='flex' align='middle' gutter={16}>
      <Col>
        <span style={{ marginRight: 8 }}>
          {I18n.t('pages.extraction.fields.dateFrom.label')}
        </span>
        <DatePicker
          format='DD/MM/YYYY'
          value={dateFrom}
          onChange={onChangeFrom}
        />
      </Col>
      <Col>
        <span style={{ marginRight: 8 }}>
          {I18n.t('pages.extraction.fields.dateTo.label')}
        </span>
        <DatePicker
          format='DD/MM/YYYY'
          value={dateTo}
          onChange={onChangeTo}
        />
      </Col>
      {onChangePermitType && (
        <Col>
          <span style={{ marginRight: 8 }}>
            {I18n.t('pages.extraction.fields.permitType.label')}
          </span>
          <Select value={permitType} onChange={onChangePermitType} style={{ minWidth: 180 }}>
            {map(this._permitTypeOptions, ({ value, label }) => (
              <Option key={value} value={value}>{label}</Option>
            ))}
          </Select>
        </Col>
      )}
      {onChangeCompany && (
        <Col>
          <span style={{ marginRight: 8 }}>
            {I18n.t('pages.extraction.fields.company.label')}
          </span>
          <Select
            allowClear
            showSearch
            showArrow
            style={{ minWidth: 220 }}
            value={companyId}
            placeholder={I18n.t('pages.extraction.fields.company.placeholder')}
            filterOption={(inputValue, option) =>
              includes(
                toString(get(option, 'props.children')).toLowerCase(),
                toString(inputValue).toLowerCase()
              )
            }
            onChange={onChangeCompany}
          >
            {map(companyOptions, ({ value, label }) => (
              <Option key={value} value={value}>{label}</Option>
            ))}
          </Select>
        </Col>
      )}
      <Col>
        <Button
          type='primary'
          icon='download'
          loading={isDownloading}
          onClick={onDownload}
        >
          {I18n.t('pages.extraction.actions.download')}
        </Button>
      </Col>
    </Row>
  )

  render() {
    const { constructorFunctions, constructorState } = this.props
    const {
      permitsDateFrom,
      permitsDateTo,
      permitsCompanyId,
      permitsPermitType,
      companyOptions,
      isDownloadingPermits,
      pdpsDateFrom,
      pdpsDateTo,
      pdpsCompanyId,
      isDownloadingPdps,
      companiesDateFrom,
      companiesDateTo,
      isDownloadingCompanies
    } = constructorState

    return (
      <main className='screen extraction extraction-list'>
        <Tabs defaultActiveKey='permits'>

          {/* Onglet Permis */}
          <TabPane tab={I18n.t('pages.extraction.tabs.permits')} key='permits'>
            <Card>
              {this._renderDateFilters({
                dateFrom: permitsDateFrom,
                dateTo: permitsDateTo,
                onChangeFrom: get(constructorFunctions, 'setPermitsDateFrom'),
                onChangeTo: get(constructorFunctions, 'setPermitsDateTo'),
                onDownload: get(constructorFunctions, 'downloadPermits'),
                isDownloading: isDownloadingPermits,
                companyId: permitsCompanyId,
                onChangeCompany: get(constructorFunctions, 'setPermitsCompanyId'),
                companyOptions,
                permitType: permitsPermitType,
                onChangePermitType: get(constructorFunctions, 'setPermitsPermitType')
              })}
            </Card>
          </TabPane>

          {/* Onglet Plans de prévention */}
          <TabPane tab={I18n.t('pages.extraction.tabs.pdps')} key='pdps'>
            <Card>
              {this._renderDateFilters({
                dateFrom: pdpsDateFrom,
                dateTo: pdpsDateTo,
                onChangeFrom: get(constructorFunctions, 'setPdpsDateFrom'),
                onChangeTo: get(constructorFunctions, 'setPdpsDateTo'),
                onDownload: get(constructorFunctions, 'downloadPdps'),
                isDownloading: isDownloadingPdps,
                companyId: pdpsCompanyId,
                onChangeCompany: get(constructorFunctions, 'setPdpsCompanyId'),
                companyOptions
              })}
            </Card>
          </TabPane>

          {/* Onglet Entreprises */}
          <TabPane tab={I18n.t('pages.extraction.tabs.companies')} key='companies'>
            <Card>
              {this._renderDateFilters({
                dateFrom: companiesDateFrom,
                dateTo: companiesDateTo,
                onChangeFrom: get(constructorFunctions, 'setCompaniesDateFrom'),
                onChangeTo: get(constructorFunctions, 'setCompaniesDateTo'),
                onDownload: get(constructorFunctions, 'downloadCompanies'),
                isDownloading: isDownloadingCompanies
              })}
            </Card>
          </TabPane>

        </Tabs>
      </main>
    )
  }
}

export default ExtractionList
